/* eslint-disable @typescript-eslint/naming-convention */
export const ROUTE_PATHS = {
  ADVERTISERS_LIST: "/advertisers",
  ADVERTISER_DETAIL: "/advertisers/:id",
  CAMPAIGNS_CREATE: "/campaigns/create",
  MANAGED_CAMPAIGN_CREATE: "/campaigns/create/managed",
  CUSTOM_CAMPAIGN_CREATE: "/campaigns/create/custom",
  CAMPAIGN_CREATE_FROM_TEMPLATE: "/campaigns/create/from-template",
  VISITORS_RE_TARGETING_SEGMENTS: "/visitors-retargeting",
  CRM_RE_TARGETING_SEGMENTS: "/crm-retargeting",
  DASHBOARD: "/dashboard",
  PUBLIC_CAMPAIGNS_PICKER: "/public-campaigns-picker",
  TERMS_PAGE: "/terms-of-use",
  PRIVACY_PAGE: "/privacy-policy",
  ROOT: "/",
  SIGNUP: "/bgsignup",
  FORGOT_PASSWORD: "/request-password-reset",
  ALLBILLINGLOGS: "/allbillinglogs",
  INVOICES: "/invoices",
  PUBLICATION_LISTS: "/publication-lists",
  ZIP_CODES: "/zip-codes",
  ADS_UPLOAD: "/ads-upload",
  TARGET_COMPANIES: "/target-companies",
  ROLES_AND_TITLES: "/roles-titles",
  SEGMENTS_LOGS: "/segments-logs",
  CAMPAIGN_TEMPLATES: "/campaign-templates",
  CREATE_CAMPAIGN_TEMPLATE: "/create-campaign-template",
};
